import React from "react";
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image";
import loadable from "@loadable/component"

import TestimonialBgDesktop from "../assets/images/testimonial_bg_desktop.svg";
import TestimonialBgMobile from "../assets/images/testimonial_bg_mobile.svg";

import { Trans, useTranslation } from "gatsby-plugin-react-i18next";
import { Divider } from "./core";

export const testimonialBgStyles = {position: 'absolute', maxWidth: '100%', height: 'auto', left: '0', top: '0'}

const Text = loadable(() => import("./core"), {
  resolveComponent: (components) => components.Text,
});
const OnDesktop = loadable(() => import("./DesktopMobileComps"), {
  resolveComponent: (components) => components.OnDesktop,
});
const OnMobile = loadable(() => import("./DesktopMobileComps"), {
  resolveComponent: (components) => components.OnMobile,
});

const Testimonials = () => {
    const {t} = useTranslation('testimonials')
    return (
      <>
        <TestimonialCard>
            <div>
              <OnDesktop>
                <StaticImage 
                  src="../assets/images/testimonial_sanchita_k.webp"
                  alt="testimonial-sanchita-k"
                  loading="lazy"
                />
              </OnDesktop>
              <OnMobileMod>
                <StaticImage 
                  src="../assets/images/testimonial_sanchita_k.webp"
                  alt="testimonial-sanchita-k"
                  loading="lazy"
                  style={{width: 'min(160px, 100%)',borderRadius: '50%'}}
                />
              </OnMobileMod>
            </div>
            <Testimonial>
              <TestimonialTextWrapper>
                <OnDesktop>
                  <TestimonialBgDesktop
                    style={testimonialBgStyles}     
                  />
                </OnDesktop>
                <OnMobile>
                  <TestimonialBgMobile
                    style={testimonialBgStyles}                
                  />
                </OnMobile>
                <TestimonialText color="#4D4D4D" mfontSize="14px">
                  <Trans 
                    i18nKey="Testimonials.0.Text"
                    components={{ bold: <strong /> }}
                  />
                </TestimonialText>
              </TestimonialTextWrapper>
              <br />
              <Text color="#000000" fontWeight="bold" fontSize="20px" mfontSize="14px">{t('Testimonials.0.UserName')}</Text>
              <Text color="#4D4D4D" fontSize="14px" style={{marginTop: '0'}} mfontSize="14px">{t('Testimonials.0.Occupation')}</Text>
            </Testimonial>
        </TestimonialCard>
        <DividerMod />
        <TestimonialCard>
          <div>
            <OnDesktop>
              <StaticImage 
                src="../assets/images/testimonial_romil.webp"
                alt="testimonial-romil"
                loading="lazy"
              />
            </OnDesktop>
            <OnMobileMod>
              <StaticImage 
                src="../assets/images/testimonial_romil.webp"
                alt="testimonial-romil"
                loading="lazy"
                style={{width: 'min(160px, 100%)',borderRadius: '50%'}}
              />
            </OnMobileMod>
          </div>
          <Testimonial>
            <TestimonialTextWrapper>
              <OnDesktop>
                <TestimonialBgDesktop
                  style={testimonialBgStyles}     
                />
              </OnDesktop>
              <OnMobile>
                <TestimonialBgMobile
                  style={testimonialBgStyles}                
                />
              </OnMobile>
              <TestimonialText color="#4D4D4D" mfontSize="14px">
                <Trans 
                  i18nKey="Testimonials.1.Text"
                  components={{ bold: <strong /> }}
                />
              </TestimonialText>
            </TestimonialTextWrapper>
            <br />
            <Text color="#000000" fontWeight="bold" fontSize="20px" mfontSize="14px">{t('Testimonials.1.UserName')}</Text>
            <Text color="#4D4D4D" fontSize="14px" style={{marginTop: '0'}} mfontSize="14px">{t('Testimonials.1.Occupation')}</Text>
          </Testimonial>
        </TestimonialCard>
        <DividerMod />
        <TestimonialCard>
          <div>
            <OnDesktop>
              <StaticImage 
                src="../assets/images/testimonial_hitesh_n.webp"
                alt="testimonial-hitesh_n"
                loading="lazy"
              />
            </OnDesktop>
            <OnMobileMod>
              <StaticImage 
                src="../assets/images/testimonial_hitesh_n.webp"
                alt="testimonial-hitesh_n"
                loading="lazy"
                style={{width: 'min(160px, 100%)',borderRadius: '50%'}}
              />
            </OnMobileMod>
          </div>
          <Testimonial>
            <TestimonialTextWrapper>
              <OnDesktop>
                <TestimonialBgDesktop
                  style={testimonialBgStyles}     
                />
              </OnDesktop>
              <OnMobile>
                <TestimonialBgMobile
                  style={{...testimonialBgStyles, height: '100%'}}                
                />
              </OnMobile>
              <TestimonialText color="#4D4D4D" mfontSize="14px" marginTop="4rem" mMarginTop="1rem">
                <Trans 
                  i18nKey="Testimonials.2.Text"
                  components={{ bold: <strong /> }}
                />
              </TestimonialText>
            </TestimonialTextWrapper>
            <br />
            <Text color="#000000" fontWeight="bold" fontSize="20px" mfontSize="14px">{t('Testimonials.2.UserName')}</Text>
            <Text color="#4D4D4D" fontSize="14px" style={{marginTop: '0'}} mfontSize="14px">{t('Testimonials.2.Occupation')}</Text>
          </Testimonial>
        </TestimonialCard>
        <DividerMod />
        <TestimonialCard>
          <div>
            <OnDesktop>
              <StaticImage 
                src="../assets/images/testimonial_gopal_c.webp"
                alt="testimonial-gopal_c"
                loading="lazy"
              />
            </OnDesktop>
            <OnMobileMod>
              <StaticImage 
                src="../assets/images/testimonial_gopal_c.webp"
                alt="testimonial-gopal_c"
                loading="lazy"
                style={{width: 'min(160px, 100%)',borderRadius: '50%'}}
              />
            </OnMobileMod>
          </div>
          <Testimonial>
            <TestimonialTextWrapper>
              <OnDesktop>
                <TestimonialBgDesktop
                  style={testimonialBgStyles}     
                />
              </OnDesktop>
              <OnMobile>
                <TestimonialBgMobile
                  style={{...testimonialBgStyles, height: '100%'}}                
                />
              </OnMobile>
              <TestimonialText color="#4D4D4D" mfontSize="14px" marginTop="4rem" mMarginTop="1rem">
                <Trans 
                  i18nKey="Testimonials.3.Text"
                  components={{ bold: <strong /> }}
                />
              </TestimonialText>
            </TestimonialTextWrapper>
            <br />
            <Text color="#000000" fontWeight="bold" fontSize="20px" mfontSize="14px">{t('Testimonials.3.UserName')}</Text>
            <Text color="#4D4D4D" fontSize="14px" style={{marginTop: '0'}} mfontSize="14px">{t('Testimonials.3.Occupation')}</Text>
          </Testimonial>
        </TestimonialCard>
        <DividerMod />
        <TestimonialCard>
          <div>
            <OnDesktop>
              <StaticImage 
                src="../assets/images/testimonial_anuj_g.webp"
                alt="testimonial-anuj_g"
                loading="lazy"
              />
            </OnDesktop>
            <OnMobileMod>
              <StaticImage 
                src="../assets/images/testimonial_anuj_g.webp"
                alt="testimonial-anuj_g"
                loading="lazy"
                style={{width: 'min(160px, 100%)',borderRadius: '50%'}}
              />
            </OnMobileMod>
          </div>
          <Testimonial>
            <TestimonialTextWrapper>
              <OnDesktop>
                <TestimonialBgDesktop
                  style={testimonialBgStyles}     
                />
              </OnDesktop>
              <OnMobile>
                <TestimonialBgMobile
                  style={{...testimonialBgStyles, height: '100%'}}                
                />
              </OnMobile>
              <TestimonialText color="#4D4D4D" mfontSize="14px" marginTop="4rem" mMarginTop="1rem">
                <Trans 
                  i18nKey="Testimonials.4.Text"
                  components={{ bold: <strong /> }}
                />
              </TestimonialText>
            </TestimonialTextWrapper>
            <br />
            <Text color="#000000" fontWeight="bold" fontSize="20px" mfontSize="14px">{t('Testimonials.4.UserName')}</Text>
            <Text color="#4D4D4D" fontSize="14px" style={{marginTop: '0'}} mfontSize="14px">{t('Testimonials.4.Occupation')}</Text>
          </Testimonial>
        </TestimonialCard>
        <DividerMod />
        <TestimonialCard>
          <div>
            <OnDesktop>
              <StaticImage 
                src="../assets/images/testimonial_deep_c.webp"
                alt="testimonial-deep_c"
                loading="lazy"
              />
            </OnDesktop>
            <OnMobileMod>
              <StaticImage 
                src="../assets/images/testimonial_deep_c.webp"
                alt="testimonial-deep_c"
                loading="lazy"
                style={{width: 'min(160px, 100%)',borderRadius: '50%'}}
              />
            </OnMobileMod>
          </div>
          <Testimonial>
            <TestimonialTextWrapper>
              <OnDesktop>
                <TestimonialBgDesktop
                  style={testimonialBgStyles}     
                />
              </OnDesktop>
              <OnMobile>
                <TestimonialBgMobile
                  style={{...testimonialBgStyles, height: '100%'}}                
                />
              </OnMobile>
              <TestimonialText color="#4D4D4D" mfontSize="14px" marginTop="4rem" mMarginTop="1rem">
                <Trans 
                  i18nKey="Testimonials.5.Text"
                  components={{ bold: <strong /> }}
                />
              </TestimonialText>
            </TestimonialTextWrapper>
            <br />
            <Text color="#000000" fontWeight="bold" fontSize="20px" mfontSize="14px">{t('Testimonials.5.UserName')}</Text>
            <Text color="#4D4D4D" fontSize="14px" style={{marginTop: '0'}} mfontSize="14px">{t('Testimonials.5.Occupation')}</Text>
          </Testimonial>
        </TestimonialCard>
        <DividerMod />
        <TestimonialCard>
          <TestimonialImgContainer>
            <OnDesktopMod>
              <StaticImage 
                src="../assets/images/testimonial_adnan_w.webp"
                alt="testimonial_adnan_w"
                loading="lazy"
                style={{width: 'min(370px, 100%)'}}
              />
            </OnDesktopMod>
            <OnMobileMod>
              <StaticImage 
                src="../assets/images/testimonial_adnan_w.webp"
                alt="testimonial_adnan_w"
                loading="lazy"
                style={{width: 'min(160px, 100%)',borderRadius: '50%', maxHeight: "160px"}}
              />
            </OnMobileMod>
          </TestimonialImgContainer>
          <Testimonial>
            <TestimonialTextWrapper>
              <OnDesktop>
                <TestimonialBgDesktop
                  style={testimonialBgStyles}     
                />
              </OnDesktop>
              <OnMobile>
                <TestimonialBgMobile
                  style={{...testimonialBgStyles, height: '100%'}}                
                />
              </OnMobile>
              <TestimonialText color="#4D4D4D" mfontSize="14px" marginTop="4rem" mMarginTop="1rem">
                <Trans 
                  i18nKey="Testimonials.6.Text"
                  components={{ bold: <strong /> }}
                />
              </TestimonialText>
            </TestimonialTextWrapper>
            <br />
            <Text color="#000000" fontWeight="bold" fontSize="20px" mfontSize="14px">{t('Testimonials.6.UserName')}</Text>
            <Text color="#4D4D4D" fontSize="14px" style={{marginTop: '0'}} mfontSize="14px">{t('Testimonials.6.Occupation')}</Text>
          </Testimonial>
        </TestimonialCard>
        <DividerMod />
        <TestimonialCard>
          <TestimonialImgContainer>
            <OnDesktopMod>
              <StaticImage 
                src="../assets/images/testimonial_chetan_v.webp"
                alt="testimonial_chetan_v"
                loading="lazy"
                style={{width: 'min(370px, 100%)'}}
              />
            </OnDesktopMod>
            <OnMobileMod>
              <StaticImage 
                src="../assets/images/testimonial_chetan_v.webp"
                alt="testimonial_chetan_v"
                loading="lazy"
                style={{width: 'min(160px, 100%)',borderRadius: '50%', maxHeight: "160px"}}
              />
            </OnMobileMod>
          </TestimonialImgContainer>
          <Testimonial>
            <TestimonialTextWrapper>
              <OnDesktop>
                <TestimonialBgDesktop
                  style={testimonialBgStyles}     
                />
              </OnDesktop>
              <OnMobile>
                <TestimonialBgMobile
                  style={{...testimonialBgStyles, height: '100%'}}                
                />
              </OnMobile>
              <TestimonialText color="#4D4D4D" mfontSize="14px" marginTop="4rem" mMarginTop="1rem">
                <Trans 
                  i18nKey="Testimonials.7.Text"
                  components={{ bold: <strong /> }}
                />
              </TestimonialText>
            </TestimonialTextWrapper>
            <br />
            <Text color="#000000" fontWeight="bold" fontSize="20px" mfontSize="14px">{t('Testimonials.7.UserName')}</Text>
            <Text color="#4D4D4D" fontSize="14px" style={{marginTop: '0'}} mfontSize="14px">{t('Testimonials.7.Occupation')}</Text>
          </Testimonial>
        </TestimonialCard>
        <DividerMod />
        <TestimonialCard>
          <TestimonialImgContainer>
            <OnDesktopMod>
              <StaticImage 
                src="../assets/images/testimonial_sanjay_m.webp"
                alt="testimonial_sanjay_m"
                loading="lazy"
                style={{width: 'min(370px, 100%)'}}
              />
            </OnDesktopMod>
            <OnMobileMod>
              <StaticImage 
                src="../assets/images/testimonial_sanjay_m_mobile.webp"
                alt="testimonial_sanjay_m"
                loading="lazy"
                style={{width: 'min(160px, 100%)',borderRadius: '50%', maxHeight: "160px"}}
              />
            </OnMobileMod>
          </TestimonialImgContainer>
          <Testimonial>
            <TestimonialTextWrapper>
              <OnDesktop>
                <TestimonialBgDesktop
                  style={testimonialBgStyles}     
                />
              </OnDesktop>
              <OnMobile>
                <TestimonialBgMobile
                  style={{...testimonialBgStyles, height: '100%'}}                
                />
              </OnMobile>
              <TestimonialText color="#4D4D4D" mfontSize="14px" marginTop="4rem" mMarginTop="1rem">
                <Trans 
                  i18nKey="Testimonials.8.Text"
                  components={{ bold: <strong /> }}
                />
              </TestimonialText>
            </TestimonialTextWrapper>
            <br />
            <Text color="#000000" fontWeight="bold" fontSize="20px" mfontSize="14px">{t('Testimonials.8.UserName')}</Text>
            <Text color="#4D4D4D" fontSize="14px" style={{marginTop: '0'}} mfontSize="14px">{t('Testimonials.8.Occupation')}</Text>
          </Testimonial>
        </TestimonialCard>
        <DividerMod />
        <TestimonialCard>
          <TestimonialImgContainer>
            <OnDesktopMod>
              <StaticImage 
                src="../assets/images/testimonial_ajai_n.webp"
                alt="testimonial_ajai_n"
                loading="lazy"
                style={{width: 'min(370px, 100%)'}}
              />
            </OnDesktopMod>
            <OnMobileMod>
              <StaticImage 
                src="../assets/images/testimonial_ajai_n.webp"
                alt="testimonial_ajai_n"
                loading="lazy"
                style={{width: 'min(160px, 100%)',borderRadius: '50%', maxHeight: "160px"}}
              />
            </OnMobileMod>
          </TestimonialImgContainer>
          <Testimonial>
            <TestimonialTextWrapper>
              <OnDesktop>
                <TestimonialBgDesktop
                  style={testimonialBgStyles}     
                />
              </OnDesktop>
              <OnMobile>
                <TestimonialBgMobile
                  style={{...testimonialBgStyles, height: '100%'}}                
                />
              </OnMobile>
              <TestimonialText color="#4D4D4D" mfontSize="14px" marginTop="4rem" mMarginTop="1rem">
                <Trans 
                  i18nKey="Testimonials.9.Text"
                  components={{ bold: <strong /> }}
                />
              </TestimonialText>
            </TestimonialTextWrapper>
            <br />
            <Text color="#000000" fontWeight="bold" fontSize="20px" mfontSize="14px">{t('Testimonials.9.UserName')}</Text>
            <Text color="#4D4D4D" fontSize="14px" style={{marginTop: '0'}} mfontSize="14px">{t('Testimonials.9.Occupation')}</Text>
          </Testimonial>
        </TestimonialCard>
        <DividerMod />
        <TestimonialCard>
          <TestimonialImgContainer>
            <OnDesktopMod>
              <StaticImage 
                src="../assets/images/testimonial_bhavya_m.webp"
                alt="testimonial_bhavya_m."
                loading="lazy"
                style={{width: 'min(370px, 100%)'}}
              />
            </OnDesktopMod>
            <OnMobileMod>
              <StaticImage 
                src="../assets/images/testimonial_bhavya_m_mobile.webp"
                alt="testimonial_bhavya_m."
                loading="lazy"
                style={{width: 'min(160px, 100%)',borderRadius: '50%', maxHeight: "160px"}}
              />
            </OnMobileMod>
          </TestimonialImgContainer>
          <Testimonial>
            <TestimonialTextWrapper>
              <OnDesktop>
                <TestimonialBgDesktop
                  style={testimonialBgStyles}     
                />
              </OnDesktop>
              <OnMobile>
                <TestimonialBgMobile
                  style={{...testimonialBgStyles, height: '100%'}}                
                />
              </OnMobile>
              <TestimonialText color="#4D4D4D" mfontSize="14px" marginTop="4rem" mMarginTop="1rem">
                <Trans 
                  i18nKey="Testimonials.10.Text"
                  components={{ bold: <strong /> }}
                />
              </TestimonialText>
            </TestimonialTextWrapper>
            <br />
            <Text color="#000000" fontWeight="bold" fontSize="20px" mfontSize="14px">{t('Testimonials.10.UserName')}</Text>
            <Text color="#4D4D4D" fontSize="14px" style={{marginTop: '0'}} mfontSize="14px">{t('Testimonials.10.Occupation')}</Text>
          </Testimonial>
        </TestimonialCard>
        <DividerMod />
        <TestimonialCard>
          <TestimonialImgContainer>
            <OnDesktopMod>
              <StaticImage 
                src="../assets/images/testimonial_jayesh_b.webp"
                alt="testimonial_jayesh_b"
                loading="lazy"
                style={{width: 'min(370px, 100%)'}}
              />
            </OnDesktopMod>
            <OnMobileMod>
              <StaticImage 
                src="../assets/images/testimonial_jayesh_b_mobile.webp"
                alt="testimonial_jayesh_b"
                loading="lazy"
                style={{width: 'min(160px, 100%)',borderRadius: '50%', maxHeight: "160px"}}
              />
            </OnMobileMod>
          </TestimonialImgContainer>
          <Testimonial>
            <TestimonialTextWrapper>
              <OnDesktop>
                <TestimonialBgDesktop
                  style={testimonialBgStyles}     
                />
              </OnDesktop>
              <OnMobile>
                <TestimonialBgMobile
                  style={{...testimonialBgStyles, height: '100%'}}                
                />
              </OnMobile>
              <TestimonialText color="#4D4D4D" mfontSize="14px" marginTop="4rem" mMarginTop="1rem">
                <Trans 
                  i18nKey="Testimonials.11.Text"
                  components={{ bold: <strong /> }}
                />
              </TestimonialText>
            </TestimonialTextWrapper>
            <br />
            <Text color="#000000" fontWeight="bold" fontSize="20px" mfontSize="14px">{t('Testimonials.11.UserName')}</Text>
            <Text color="#4D4D4D" fontSize="14px" style={{marginTop: '0'}} mfontSize="14px">{t('Testimonials.11.Occupation')}</Text>
          </Testimonial>
        </TestimonialCard>
        <DividerMod />
        <TestimonialCard>
          <TestimonialImgContainer>
            <OnDesktopMod>
              <StaticImage 
                src="../assets/images/testimonial_shubham_g.webp"
                alt="testimonial_shubham_g"
                loading="lazy"
                style={{width: 'min(370px, 100%)'}}
              />
            </OnDesktopMod>
            <OnMobileMod>
              <StaticImage 
                src="../assets/images/testimonial_shubham_g_mobile.webp"
                alt="testimonial_shubham_g"
                loading="lazy"
                style={{width: 'min(160px, 100%)',borderRadius: '50%', maxHeight: "160px"}}
              />
            </OnMobileMod>
          </TestimonialImgContainer>
          <Testimonial>
            <TestimonialTextWrapper>
              <OnDesktop>
                <TestimonialBgDesktop
                  style={testimonialBgStyles}     
                />
              </OnDesktop>
              <OnMobile>
                <TestimonialBgMobile
                  style={{...testimonialBgStyles, height: '100%'}}                
                />
              </OnMobile>
              <TestimonialText color="#4D4D4D" mfontSize="14px" marginTop="4rem" mMarginTop="1rem">
                <Trans 
                  i18nKey="Testimonials.12.Text"
                  components={{ bold: <strong /> }}
                />
              </TestimonialText>
            </TestimonialTextWrapper>
            <br />
            <Text color="#000000" fontWeight="bold" fontSize="20px" mfontSize="14px">{t('Testimonials.12.UserName')}</Text>
            <Text color="#4D4D4D" fontSize="14px" style={{marginTop: '0'}} mfontSize="14px">{t('Testimonials.12.Occupation')}</Text>
          </Testimonial>
        </TestimonialCard>
        <DividerMod />
        <TestimonialCard>
          <div>
            <OnDesktop>
              <StaticImage 
                src="../assets/images/testimonial_zafar_k.webp"
                alt="testimonial-zafar-k"
                loading="lazy"
              />
            </OnDesktop>
            <OnMobileMod>
              <StaticImage 
                src="../assets/images/testimonial_zafar_k.webp"
                alt="testimonial-zafar-k"
                loading="lazy"
                style={{width: 'min(160px, 100%)',borderRadius: '50%'}}
              />
            </OnMobileMod>
          </div>
          <Testimonial>
            <TestimonialTextWrapper>
              <OnDesktop>
                <TestimonialBgDesktop
                  style={testimonialBgStyles}     
                />
              </OnDesktop>
              <OnMobile>
                <TestimonialBgMobile
                  style={{...testimonialBgStyles, height: '100%'}}                
                />
              </OnMobile>
              <TestimonialText color="#4D4D4D" mfontSize="14px" marginTop="4rem" mMarginTop="1rem">
                <Trans 
                  i18nKey="Testimonials.13.Text"
                  components={{ bold: <strong /> }}
                />
              </TestimonialText>
            </TestimonialTextWrapper>
            <br />
            <Text color="#000000" fontWeight="bold" fontSize="20px" mfontSize="14px">{t('Testimonials.13.UserName')}</Text>
            <Text color="#4D4D4D" fontSize="14px" style={{marginTop: '0'}} mfontSize="14px">{t('Testimonials.13.Occupation')}</Text>
          </Testimonial>
        </TestimonialCard>
        <DividerMod />
        <TestimonialCard>
          <div>
            <OnDesktop>
              <StaticImage 
                src="../assets/images/testimonial_vineet_m.webp"
                alt="testimonial-vineet-m"
                loading="lazy"
              />
            </OnDesktop>
            <OnMobileMod>
              <StaticImage 
                src="../assets/images/testimonial_vineet_m.webp"
                alt="testimonial-vineet-m"
                loading="lazy"
                style={{width: 'min(160px, 100%)',borderRadius: '50%'}}
              />
            </OnMobileMod>
          </div>
          <Testimonial>
            <TestimonialTextWrapper>
              <OnDesktop>
                <TestimonialBgDesktop
                  style={testimonialBgStyles}     
                />
              </OnDesktop>
              <OnMobile>
                <TestimonialBgMobile
                  style={{...testimonialBgStyles, height: '100%'}}                
                />
              </OnMobile>
              <TestimonialText color="#4D4D4D" mfontSize="14px" marginTop="4rem" mMarginTop="1rem">
                <Trans 
                  i18nKey="Testimonials.14.Text"
                  components={{ bold: <strong /> }}
                />
              </TestimonialText>
            </TestimonialTextWrapper>
            <br />
            <Text color="#000000" fontWeight="bold" fontSize="20px" mfontSize="14px">{t('Testimonials.14.UserName')}</Text>
            <Text color="#4D4D4D" fontSize="14px" style={{marginTop: '0'}} mfontSize="14px">{t('Testimonials.14.Occupation')}</Text>
          </Testimonial>
        </TestimonialCard>
        <DividerMod />
        <TestimonialCard>
          <div>
            <OnDesktop>
              <StaticImage 
                src="../assets/images/testimonial_deepak_k.webp"
                alt="testimonial-deepak-k"
                loading="lazy"
              />
            </OnDesktop>
            <OnMobileMod>
              <StaticImage 
                src="../assets/images/testimonial_deepak_k.webp"
                alt="testimonial-deepak-k"
                loading="lazy"
                style={{width: 'min(160px, 100%)',borderRadius: '50%'}}
              />
            </OnMobileMod>
          </div>
          <Testimonial>
            <TestimonialTextWrapper>
              <OnDesktop>
                <TestimonialBgDesktop
                  style={testimonialBgStyles}     
                />
              </OnDesktop>
              <OnMobile>
                <TestimonialBgMobile
                  style={{...testimonialBgStyles, height: '100%'}}                
                />
              </OnMobile>
              <TestimonialText color="#4D4D4D" mfontSize="14px" marginTop="4rem" mMarginTop="1rem">
                <Trans 
                  i18nKey="Testimonials.15.Text"
                  components={{ bold: <strong /> }}
                />
              </TestimonialText>
            </TestimonialTextWrapper>
            <br />
            <Text color="#000000" fontWeight="bold" fontSize="20px" mfontSize="14px">{t('Testimonials.15.UserName')}</Text>
            <Text color="#4D4D4D" fontSize="14px" style={{marginTop: '0'}} mfontSize="14px">{t('Testimonials.15.Occupation')}</Text>
          </Testimonial>
        </TestimonialCard>
      </>
    )
  }

export default Testimonials;

export const TestimonialCard = styled.div`
    width: min(1280px, 100%);
    display: flex;
    justify-content: space-around;
    margin: auto;
    @media screen and (max-width: 768px) {
        width: min(300px, 100%);
        flex-direction: column;
    }
`

export const TestimonialImgContainer = styled.div`
  width: min(370px, 100%);
`

export const Testimonial = styled.div`
  position: relative;
  width: min(600px, 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 30px;
  height: 100%;
  @media screen and (max-width: 768px) {
    margin-top: 1rem;
    padding: 0 10px;
  }
`

export const TestimonialTextWrapper = styled.div`
  position: relative; 
  width: 100%; 
  margin-bottom: 3rem;
  @media screen and (max-width: 768px) {
    margin-bottom: 0rem;
  }
`

export const TestimonialText = styled(Text)`
  margin-top: ${p => p.marginTop || "5.5rem"};
  line-height: 28.8px;
  @media screen and (max-width: 768px) {
    margin-top: ${p => p.mMarginTop || "1.25rem"};
  }
`

export const OnMobileMod = styled(OnMobile)`
  @media (max-width: 768px) {
    width: min(160px, 100%);
    margin: auto;
  }
`
export const OnDesktopMod = styled(OnDesktop)`
    width: min(370px, 100%);
    margin: auto;
`

export const DividerMod = styled(Divider)`
  margin-top: 5rem;
  margin-bottom: 5rem;
  @media screen and (max-width: 768px) {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }
`